export const tr = {
    'change-success': 'Ürün değiştirildi',
    error: 'Hata oluştu, daha sonra tekrar deneyin'
};
